import { Box, Typography, Slider } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

/** Capa superior compartida con el resto de listados (inventario, etc.). */
export {
  ListPageFilterContainer as FilterContainer,
  ListPageFilterRow as FilterRow,
  ListPageCatalogSecondaryFilterRow as SecondaryFilterRow,
  ListPageFilterTextField as StyledTextField,
  ListPageFilterModernButton as ModernButton,
  ListPageFilterCollapse as FilterCollapse,
} from '../../common/list-page/listPageFilter.styles';

/** Solo catálogo: filtro por peso (slider). */
export const WeightContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '56px',
  gridColumn: 'span 2',
}));

export const WeightLabel = styled(Typography)(({ theme }) => ({
  fontSize: '0.75rem',
  fontWeight: 500,
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(0.5),
  paddingLeft: theme.spacing(1),
}));

export const WeightSliderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  height: '40px',
  padding: theme.spacing(0, 1.5),
  borderRadius: theme.spacing(1.5),
  backdropFilter: 'blur(10px)',
  transition: 'all 0.2s ease-in-out',
  ...(theme.palette.mode === 'dark'
    ? {
        backgroundColor: alpha(theme.palette.common.white, 0.06),
        border: `1px solid ${alpha(theme.palette.success.main, 0.45)}`,
        '&:hover': {
          backgroundColor: alpha(theme.palette.common.white, 0.1),
          borderColor: theme.palette.success.main,
        },
        '&:focus-within': {
          backgroundColor: alpha(theme.palette.common.white, 0.12),
          borderColor: '#0BB296',
          borderWidth: '2px',
          padding: theme.spacing(0, 1.4),
        },
      }
    : {
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        border: `1px solid ${alpha(theme.palette.success.main, 0.45)}`,
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderColor: theme.palette.success.main,
        },
        '&:focus-within': {
          backgroundColor: '#ffffff',
          borderColor: '#0BB296',
          borderWidth: '2px',
          padding: theme.spacing(0, 1.4),
        },
      }),
}));

export const WeightInput = styled('input')(({ theme }) => ({
  border: 'none',
  outline: 'none',
  backgroundColor: 'transparent',
  width: '45px',
  textAlign: 'center',
  fontSize: '0.75rem',
  color: theme.palette.text.primary,
  fontWeight: 500,
  '&::placeholder': {
    color: theme.palette.text.disabled,
    fontSize: '0.75rem',
  },
}));

export const StyledSlider = styled(Slider)(({ theme }) => ({
  flex: 1,
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(1),
  '& .MuiSlider-track': {
    border: 'none',
    height: 4,
    borderRadius: 2,
    background: 'linear-gradient(to right, #06b6d4, #10b981)',
  },
  '& .MuiSlider-rail': {
    color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[300],
    opacity: 1,
    height: 4,
    borderRadius: 2,
  },
  '& .MuiSlider-thumb': {
    height: 16,
    width: 16,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #06b6d4',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: '0 3px 12px rgba(6, 182, 212, 0.4)',
    },
    '&:before': {
      display: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 11,
    background: '#374151',
    padding: theme.spacing(0.25, 0.75),
    borderRadius: theme.spacing(0.75),
    color: 'white',
    '&:before': {
      borderColor: '#374151',
    },
  },
}));

export const WeightUnit = styled(Typography)(({ theme }) => ({
  fontSize: '0.75rem',
  color: theme.palette.text.secondary,
  fontWeight: 500,
  minWidth: '15px',
}));
